import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthContext } from "./Context/AuthContext";
import Login from "./pages/Login";
import LandingPage from "./pages/LandingPage";
import DashboardLayout from "./Layout/Dashboard";
import DashboardContent from "./Layout/DashboardContent";
import EditHomeLoan from "./pages/Forms/HomeLoan/EditHomeLoan";
import EditBusinessLoan from "./pages/Forms/BusinessLoan/EditBusinessLoan";
import EditPersonalLoan from "./pages/Forms/PersonalLoan/EditPersonalLoan";
import CreateHomeForm from "./pages/Forms/HomeLoan/CreateHomeForm";
import CreatePersonalForm from "./pages/Forms/PersonalLoan/CreatePersonalForm";
import CreateBusinessForm from "./pages/Forms/BusinessLoan/CreateBusinessForm";
import CreateCarForm from "./pages/Forms/CarLoan/CreateCarForm";
import CreateCreditCardForm from "./pages/Forms/CreditCard/CreateCreditCardForm";
import CreateInsuranceForm from "./pages/Forms/Insurance/CreateInsuranceForm";
import CreateMortgageForm from "./pages/Forms/MortgageLoan/CreateMortgageForm";
import EditMortgageLoan from "./pages/Forms/MortgageLoan/EditMortgageLoan";
import EditCarLoan from "./pages/Forms/CarLoan/EditCarLoan";
import EditCreditCardForm from "./pages/Forms/CreditCard/EditCreditForm";
import EditInsuranceLoan from "./pages/Forms/Insurance/EditInsuranceLoan";
import EditEmployeeForm from "./pages/Employee/EditEmployeeForm";
import CreateEmployeeForm from "./pages/Employee/CreateEmployeeForm";
import Profile from "./pages/Profile/Profile";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import NewServices from "./components/NewServices";
import LogoutAlertPage from "./common/LogoutAlertPage";
import HomeSection from "./components/HomeSection";
import WhyChoose from "./components/WhyChooseSection";
import AboutUs from "./pages/AboutUs";
import ContactSection from "./common/ContactAs";
import Layout from "./components/Layout";
import EmployeeList from "./pages/Employee/EmployeeFromList";
import HomeLoanList from "./pages/Forms/HomeLoan/HomeLoanList";
import PersonalLoanList from "./pages/Forms/PersonalLoan/PersonalLoanList";
import BusinessLoanList from "./pages/Forms/BusinessLoan/BusinessLoanList";
import CarLoanList from "./pages/Forms/CarLoan/CarLoanList";
import MortgageLoanList from "./pages/Forms/MortgageLoan/MortgageLoanList";
import CreditCardList from "./pages/Forms/CreditCard/CreditCardList";
import InsuranceList from "./pages/Forms/Insurance/InsuranceList";
import OTPVerification from "./components/OTPVerification";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GetInTouch from "./components/GetInTouch";
import HowItWorksPage from "./pages/HowItWorksPage";
import ChangePassword from "./pages/Profile/ChangePassword";
import DoctotrLoanList from "./pages/Forms/DoctorLoan/DoctorLoanList"
import CreateDoctorForm from "./pages/Forms/DoctorLoan/CreateDoctorForm";
import EditDoctorLoan from "./pages/Forms/DoctorLoan/EditDoctorLoan";
import CreateNriForm from "./pages/Forms/NriLoan/CreateNriForm";
import EditNriLoan from "./pages/Forms/NriLoan/EditNriLoan";
import NriLoanList from "./pages/Forms/NriLoan/NriLoanList";
import SignupForm from "./pages/Signup/SignupForm"
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ForgotPassword/ResetPassword";
import CreateBankForm from "./pages/Forms/Bank/CreateBank";
import BankList from "./pages/Forms/Bank/BankList";
import EditBankForm from "./pages/Forms/Bank/EditBank";
import CreateCompanyForm from "./pages/Forms/Company/CreateCompany";
import EditCompanyForm from "./pages/Forms/Company/EditCompany";
import CompanyList from "./pages/Forms/Company/CompanyList";
import CompanyBulkUpload from "./pages/Forms/Company/BulkCompany";
import CompanyBulkDelete from "./pages/Forms/Company/BulkCompanyDelete";
import ProductTermsAndConditions from "./components/ProductTerms&Conditions";
import RewardsProgram from "./components/RewardsProgram";
import Disclaimer from "./components/Disclaimer";
import TestiMonials from "./components/TestiMonials";
import OurServices from "./components/OurServices";
import FAQ from "./components/FAQ";


const App = () => {
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/home" element={<HomeSection />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/services" element={<NewServices />} />
        <Route path="/why-choose" element={<WhyChoose />} />
        <Route path="/contact-as" element={<ContactSection />} />
        <Route path="/get-in-touch" element={<GetInTouch />} />
        <Route path="/otp-verification" element={<OTPVerification />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/testimonials" element={<TestiMonials />} />
        <Route path="/our-services" element={<OurServices />} />
        <Route path="/faq" element={<FAQ />} />
        <Route
          path="/product-terms-conditions"
          element={<ProductTermsAndConditions />}
        />
        <Route path="/rewards-program" element={<RewardsProgram />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route
          path="/login"
          element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login />}
        />
        <Route
          path="/forgot-password"
          element={
            isLoggedIn ? <Navigate to="/dashboard" /> : <ForgotPassword />
          }
        />
        <Route
          path="/reset-password/:token"
          element={
            isLoggedIn ? <Navigate to="/dashboard" /> : <ResetPassword />
          }
        />
        <Route
          path="/signup"
          element={isLoggedIn ? <Navigate to="/dashboard" /> : <SignupForm />}
        />
        <Route
          exact
          path="/dashboard"
          element={
            isLoggedIn ? (
              <Layout>
                <ToastContainer />
                <DashboardLayout />
              </Layout>
            ) : (
              <DashboardContent />
            )
          }
        />
        <Route
          path="/create-home-loan"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateHomeForm />
              </Layout>
            ) : (
              <CreateHomeForm />
            )
          }
        />
        <Route
          path="/create-personal-loan"
          element={
            isLoggedIn ? (
              <Layout>
                <CreatePersonalForm />
              </Layout>
            ) : (
              <CreatePersonalForm />
            )
          }
        />
        <Route
          path="/create-business-loan"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateBusinessForm />
              </Layout>
            ) : (
              <CreateBusinessForm />
            )
          }
        />
        <Route
          path="/create-car-loan"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateCarForm />
              </Layout>
            ) : (
              <CreateCarForm />
            )
          }
        />
        <Route
          path="/create-credit-card"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateCreditCardForm />
              </Layout>
            ) : (
              <CreateCreditCardForm />
            )
          }
        />
        <Route
          path="/create-insurance"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateInsuranceForm />
              </Layout>
            ) : (
              <CreateInsuranceForm />
            )
          }
        />
        <Route
          path="/create-mortgage-loan"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateMortgageForm />
              </Layout>
            ) : (
              <CreateMortgageForm />
            )
          }
        />
        <Route
          path="/create-doctor-loan"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateDoctorForm />
              </Layout>
            ) : (
              <CreateDoctorForm />
            )
          }
        />
        <Route
          path="/create-nri-loan"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateNriForm />
              </Layout>
            ) : (
              <CreateNriForm />
            )
          }
        />
        <Route
          path="/create-bank"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateBankForm />
              </Layout>
            ) : (
              <CreateBankForm />
            )
          }
        />
        <Route
          path="/create-employee"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateEmployeeForm />
              </Layout>
            ) : (
              <CreateEmployeeForm />
            )
          }
        />
        <Route
          path="/create-company"
          element={
            isLoggedIn ? (
              <Layout>
                <CreateCompanyForm />
              </Layout>
            ) : (
              <CreateCompanyForm />
            )
          }
        />
        <Route
          path="/edit-business-loan/:id"
          element={
            <Layout>
              <EditBusinessLoan />
            </Layout>
          }
        />
        <Route
          path="/edit-home-loan/:id"
          element={
            <Layout>
              <EditHomeLoan />
            </Layout>
          }
        />
        <Route
          path="/edit-personal-loan/:id"
          element={
            <Layout>
              <EditPersonalLoan />
            </Layout>
          }
        />
        <Route
          path="/edit-mortgage-loan/:id"
          element={
            <Layout>
              <EditMortgageLoan />
            </Layout>
          }
        />
        <Route
          path="/edit-car-loan/:id"
          element={
            <Layout>
              <EditCarLoan />
            </Layout>
          }
        />
        <Route
          path="/edit-creditcard-loan/:id"
          element={
            <Layout>
              <EditCreditCardForm />
            </Layout>
          }
        />
        <Route
          path="/edit-insurance-loan/:id"
          element={
            <Layout>
              <EditInsuranceLoan />
            </Layout>
          }
        />
        <Route
          path="/edit-nri-loan/:id"
          element={
            <Layout>
              <EditNriLoan />
            </Layout>
          }
        />
        <Route
          path="/edit-doctor-loan/:id"
          element={
            <Layout>
              <EditDoctorLoan />
            </Layout>
          }
        />
        <Route
          path="/edit-employee/:id"
          element={
            <Layout>
              <EditEmployeeForm />
            </Layout>
          }
        />
        <Route
          path="/edit-bank/:id"
          element={
            <Layout>
              <EditBankForm />
            </Layout>
          }
        />
        <Route
          path="/edit-company/:id"
          element={
            <Layout>
              <EditCompanyForm />
            </Layout>
          }
        />
        <Route
          path="/profile"
          element={
            <Layout>
              <Profile />
            </Layout>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/logout-alert" element={<LogoutAlertPage />} />{" "}
        <Route
          path="/employee-list"
          element={
            <Layout>
              <ToastContainer />
              <EmployeeList />
            </Layout>
          }
        />
        <Route
          path="/homeloanlist"
          element={
            <Layout>
              <ToastContainer />
              <HomeLoanList />
            </Layout>
          }
        />
        <Route
          path="/personalloanlist"
          element={
            <Layout>
              <ToastContainer />
              <PersonalLoanList />
            </Layout>
          }
        />
        <Route
          path="/businessloanlist"
          element={
            <Layout>
              <ToastContainer />
              <BusinessLoanList />
            </Layout>
          }
        />
        <Route
          path="/carloanlist"
          element={
            <Layout>
              <ToastContainer />
              <CarLoanList />
            </Layout>
          }
        />
        <Route
          path="/mortgageloanlist"
          element={
            <Layout>
              <ToastContainer />
              <MortgageLoanList />
            </Layout>
          }
        />
        <Route
          path="/creditcardlist"
          element={
            <Layout>
              <ToastContainer />
              <CreditCardList />
            </Layout>
          }
        />
        <Route
          path="/insurancelist"
          element={
            <Layout>
              <ToastContainer />
              <InsuranceList />
            </Layout>
          }
        />
        <Route
          path="/doctorloanlist"
          element={
            <Layout>
              <ToastContainer />
              <DoctotrLoanList />
            </Layout>
          }
        />
        <Route
          path="/nriloanlist"
          element={
            <Layout>
              <ToastContainer />
              <NriLoanList />
            </Layout>
          }
        />
        <Route
          path="/banklist"
          element={
            <Layout>
              <ToastContainer />
              <BankList />
            </Layout>
          }
        />
        <Route
          path="/companylist"
          element={
            <Layout>
              <ToastContainer />
              <CompanyList />
            </Layout>
          }
        />
        <Route
          path="/changepassword"
          element={
            <Layout>
              <ToastContainer />
              <ChangePassword />
            </Layout>
          }
        />
        <Route
          path="/company-bulk-upload"
          element={
            <Layout>
              <ToastContainer />
              <CompanyBulkUpload />
            </Layout>
          }
        />
        <Route
          path="/company-bulk-delete"
          element={
            <Layout>
              <ToastContainer />
              <CompanyBulkDelete />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
